import {RoomBaseApiService} from "./room.baseapi.service";
import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'

export class RoomWaitingService extends RoomBaseApiService {
  async findAllByRoomId(params) {
    try {
      const response = await this.request().get(`/api/v3/waiting-room/${params.roomId}/users`, {
        ...params
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async isEnabled(params) {
    try {
      const response = await this.request().get(`/api/v3/waiting-room/${params.roomId}/enabled`, {
        ...params
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async approval(params) {
    try {
      const response = await this.request().post(`/api/v3/waiting-room/${params.roomId}/approval`, {
        ...params
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async requestEnter(params) {
    try {
      const response = await this.request().post(`/api/v3/waiting-room/${params.roomId}/request-enter`, {
        ...params
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async leave(params) {
    try {
      const response = await this.request().post(`/api/v3/waiting-room/${params.roomId}/leave`, {
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async disableWaitingRoom(params) {
    try {
      const response = await this.request().post(`/api/v3/waiting-room/${params.roomId}/disable`, {
        ...params
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async testNoManagerInRoom(params) {
    try {
      const response = await this.request().get(`/api/v3/waiting-room/${params.roomId}/test-no-manager`, {
        ...params
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  async testCloseRoom(params) {
    try {
      const response = await this.request().get(`/api/v3/waiting-room/${params.roomId}/test-close-room`, {
        ...params
      })
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomWaitingService = new RoomWaitingService()